import React, { useState } from "react";
import {
  Page,
  Text,
  Image,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
} from "@react-pdf/renderer";
import {
  cargando,
  conductor,
  descargar,
  estado,
  pasajero,
  punto_de_partida,
  punto_destino,
  recibo,
  tocar_afuera_para_cerrar,
} from "../../utils/traductor";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import logoLocalPoint from "../../imagenes/logo.png";
import CloseIcon from "@mui/icons-material/Close";

export function VerReciboViaje(props) {
  const [visible, setVisible] = useState(true);

  return (
    <div>
      {props.PrecioSugerido !== null &&
      props.PrecioSugerido !== "null" &&
      props.PrecioSugerido !== "" &&
      props.PrecioSugerido !== undefined &&
      props.PrecioSugerido !== "undefined" ? (
        <div>
          <PDFDownloadLink
            document={
              <Document>
                <Page
                  size="A4"
                  style={{
                    flexDirection: "row",
                    textAlign: "center",
                  }}
                >
                  <View
                    style={{
                      margin: 10,
                      padding: 10,
                      flexGrow: 1,
                    }}
                  >
                    <Text>Local Point</Text>
                    <Text>{recibo}</Text>
                    <Text>{"\n"} </Text>
                    <Text>$ {props.PrecioSugerido}</Text>
                    <Text>{props.FechaHoraSolicitud}</Text>
                    <Text>{"\n"} </Text>
                    <Text>{punto_de_partida}</Text>
                    <Text>{props.PartidaDireccion}</Text>
                    <Text>{"\n"} </Text>
                    <Text>{punto_destino}</Text>
                    <Text>{props.DestinoDireccion}</Text>
                    <Text>{"\n"} </Text>
                    <Text>{pasajero}</Text>
                    <Text>{props.Pasajero}</Text>
                    <Text>{"\n"} </Text>
                    <Text>{conductor}</Text>
                    <Text>{props.Chofer}</Text>
                    <Text>{"\n"} </Text>
                    <Text>{estado}</Text>
                    <Text>{props.Estado}</Text>
                    <Text>{"\n"} </Text>
                    <Text>Kms: {props.Kms}</Text>
                    <Text>Min: {props.Min}</Text>
                    <Text>{"\n"} </Text>
                    <Text>#{props.ViajeId}</Text>
                  </View>
                </Page>
              </Document>
            }
            fileName={"ReciboViaje_" + props.ViajeId + ".pdf"}
          >
            {({ loading, url, error, blob }) =>
              loading ? (
                <div>
                  <IconButton>
                    <DownloadIcon />
                  </IconButton>
                  <br></br>
                  {cargando}
                </div>
              ) : (
                <div>
                  <IconButton>
                    <DownloadIcon />
                  </IconButton>
                  <br></br>
                  {descargar}
                </div>
              )
            }
          </PDFDownloadLink>
        </div>
      ) : (
        <div></div>
      )}
      <br></br>
      <div style={{ marginBottom: "-20px" }}>
        <small>{tocar_afuera_para_cerrar}</small>
      </div>
    </div>
  );
}
